import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import ClinicsView from '../views/ClinicsView.vue'
import HomeView from '../views/HomeView.vue'
import { useUserContextStore } from '../stores/userContext'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/clinics'
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      props: true,
    },
    {
      path: '/clinics',
      name: 'clinics',
      component: ClinicsView,
      props: true,
    },
    {
      path: '/clinics/:clinicId',
      name: 'home',
      component: HomeView,
      props: true,
      redirect: { name: 'patients-search' },
      children: [
        {
          path: 'patients',
          name: 'patients-search',
          component: () => import('../views/patients/PatientsSearch.vue'),
          props: true,
        },
        {
          path: 'patients/:patientId',
          name: 'patients-overview',
          component: () => import('../views/patients/PatientsOverview.vue'),
          props: true,
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('../views/AccountSettingsView.vue'),
          props: true,
        },
      ],
    },
    
  ],
})

// Global guard for authentication
router.beforeEach((to, from, next) => {
  const store = useUserContextStore() // ✅ move store inside here
  const isAuthenticated = !!store.user
  if (!isAuthenticated && to.meta.requiresAuth) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
